import React, { Fragment } from "react";
import CustomPropTypes from "../utils/customPropTypes";
import PropTypes from "prop-types";
export default class ImageBlock extends React.Component {
  static propTypes = {
    image: CustomPropTypes.Image,
    addWrapper: PropTypes.bool,
    imgClassName: PropTypes.string,
    width: PropTypes.string,
    addImageAsBg: PropTypes.bool
  };
  static defaultProps = {
    addWrapper: true,
    addImageAsBg: false,
    imgClassName: "img-object"
  };
  getImageHTML = () => {
    if (!this.props.image) return null;
    let img = (
      <img
        width={this.props.width}
        src={this.props.image.url}
        alt={this.props.image.title}
        className={this.props.imgClassName}
      />
    );

    if (this.props.addImageAsBg)
      img = (
        <div className="img-cover" style={ {backgroundImage: "url("+ this.props.image.url+")"} } >{img}</div>
      );
    if (this.props.addWrapper) {
      img = (
        <section className="img-section">
          <div className="container">{img}</div>
        </section>
      );
    }
    return img;
  };
  render() {
    return this.getImageHTML();
  }
}
